import React from 'react';

export default class AddressEditor extends React.Component {
  constructor(props){
    super(props);

    // this.state = {questions: this.props.data };
    this.wasRenderedWithDefaultShipping = this.props.entry_is_default_shipping != undefined;
    this.wasRenderedWithDefaultBilling = this.props.entry_is_default_billing != undefined;

    this.state = this.props.data;
    this.state.entry_is_default_billing = this.props.entry_is_default_billing ;
    this.state.entry_is_default_shipping = this.props.entry_is_default_shipping;

    this.state.state_values = this.props.address_states[this.props.data.entry_country_id] || [];
    this.state.errors = this.props.errors;
    this.state.error_keys = Object.keys(this.props.errors);

    this.countryChange = this.countryChange.bind(this);
    this.zoneState = this.zoneState.bind(this);
    this.getCityState = this.getCityState.bind(this);
    this.handleChange = this.handleChange.bind(this);
 
  }

  unitedStatesCountry(){
    return 223;
  }


  handleChange(event) {

    var name = event.target.name;
    name = name.replace("address[","");
    name = name.replace("]","");
    var change = {};
    if (event.target.type == 'checkbox'){
      

      change[name] = event.target.checked;

    }
 
    else {
    change[name] = event.target.value;
    }

    this.setState(change);
    this.setState(this.errorChange(name));
  }

  errorChange(key){
    var change = {}
    if(this.state.errors[key]){
      var keys = this.state.errors;
      delete keys[key];
      change["errors"] = keys;
    }
    return change;
  }

  componentDidMount() {
    if (this.props.data.entry_postcode) {
    this.getCityState({target: {value: this.props.data.entry_postcode}})
    }

  }

  getCityState(e){
    if(this.state.entry_country_id == this.unitedStatesCountry()){
    var t = this;

      $.ajax({
        method: 'GET',
        url: Routes.zip_search_path(e.target.value),
        dataType: 'JSON',
        success: function(data){
          var city = data.zip_details.city;
          t.setState(t.errorChange("entry_city"));
          t.setState(t.errorChange("entry_zone_id"));

          t.setState({entry_city: city, entry_zone_id: data.zip_details.zone_id});
        }, 
         error: function(data, statusText, xhr){
          t.setState(t.errorChange("entry_postcode"));
          t.setState({errors: {entry_postcode: 'No zip found'}})

      }

      });
    }
  }

  buttonText(){
   if(!this.props.new_record){
     return "Save";
   }
    else if (this.props.submit_text) {
      return this.props.submit_text;
    }
   else if(this.props.no_login_quote) {
     return "Get quote";
   }

   else {
     return "Add";
   }
  }

  zoneState(){
    var state_field = null;
    var t = this;
   if(this.state && this.state.state_values && this.state.state_values.length > 0){
     var state_ddl_values = this.state.state_values.map(function (state) {
       return (<option key={state.zone_id} value={state.zone_id}>{state.zone_name}</option>);
     });
     state_field = (
       <div>
       <select name="address[entry_zone_id]" value={t.state.entry_zone_id} onChange={t.handleChange} className="form-control">
        {state_ddl_values}
       </select>
       <input type="hidden" name="address[entry_state]" value=""></input>
      </div> 
     );
   }
   else{
     state_field = (
        <input className="form-control" placeholder="State" type="text" value={this.state.entry_state} onChange={t.handleChange} name="address[entry_state]" id="address_entry_state"></input>
     );
   }
     return state_field;
  }

  countryChange(e){
    this.setState({entry_postcode: "", entry_city: "", entry_state: "", entry_zone_id: 0, entry_country_id: e.target.value, entry_suburb: ""});
    this.setupStatesField(e.target.value);
  }

  setupStatesField(countryId){
    var states_vals = this.props.address_states[countryId];
    if(states_vals === undefined){
      states_vals = [];
    }
    this.setState({state_values:  states_vals});
  }

  hiddenFields(){
  var csrfToken = $('meta[name=csrf-token]').attr('content');
   var standard_hidden_fields = (
    <i>
      <input type='hidden' name='utf8' value='✓' />
      <input type='hidden' name='authenticity_token' value={csrfToken} />
    </i>
   );
   if(!this.props.new_record){
    return (
      <i>
      <input type='hidden' name='_method' value='patch' />
      <input type='hidden' name='address[address_book_id]' value={this.state.address_book_id} />
      {standard_hidden_fields}
      </i>
    );
   }
   else{
     return standard_hidden_fields;
   }
  }

  savePath(){
    return this.props.post_url;

    if(this.props.new_record){
      return ;
    }
    else{
      return Routes.address_path(this.state.address_book_id);
    }

  }

  errorMessage(key){
    var message = "";
    if(this.state.errors[key]){
      message = this.state.errors[key];
    }
    return (
          <span className="text-danger">{message}</span>
    );
  }

  cssForField(key){
    var final_css = "form-group";
    if(this.state.errors[key]){
    final_css += " has-error"
    }
    return final_css;
  }

  errorAlert(){
    var error_alert = "";
   if(this.state.error_keys.length > 0){
     error_alert = (
      <div className="alert alert-danger fade in">
          <a href="#" className="close" data-dismiss="alert">×</a>
          <strong>Error!</strong> A problem has been occurred while saving.<br/>
          Correct and try again.
      </div>
     );
    }
    return error_alert;
  }
   

  render(){
    var t = this;

      var country_options = this.props.countries.map(function (type){
        return (<option key={type.countries_id} value={type.countries_id}>{type.countries_name}</option>);
      });

   var id_field = "";
   if(this.state.address_book_id !== undefined && this.state.address_book_id !== null){
     id_field = (
        <input type='hidden' name='address[address_book_id]' value={this.state.address_book_id} />
     );
   }

   var error_classes = {
     entry_firstname: {css_class:""} 
   };

   if(this.state.error_keys.length > 0){
    this.state.error_keys.forEach(function (elem){
      error_classes[elem] = {css_class: "has-error has-feedback"}
      error_classes[elem].feedback = (
        <span className="text-danger">{t.state.errors[elem]}</span>
      );
    });
   } 

   var is_default_billing_checkbox = "";

   if (this.wasRenderedWithDefaultBilling){
     is_default_billing_checkbox = (<div className='input-group-addon styled-checkbox-addon'>
            <label> {'Set as default billing address?'}</label>
            <input className="form-check"  type="checkbox" checked={this.state.entry_is_default_billing} name="address[entry_is_default_billing]" 
            onChange={this.handleChange}  id="address_entry_is_default_billing"></input>
            </div>);
   }

   var is_default_shipping_checkbox = "";
      if (this.wasRenderedWithDefaultShipping){
     is_default_shipping_checkbox = (<div className='input-group-addon styled-checkbox-addon'>
            <label> {'Set as default shipping address?'}</label>
            <input className="form-check"  type="checkbox" checked={this.state.entry_is_default_shipping} name="address[entry_is_default_shipping]" 
            onChange={this.handleChange}   id="address_entry_is_default_shipping"></input>
            </div>);
   }



    return (
      <form action={t.savePath()} method={'post'} acceptCharset='UTF-8'>
        {this.props.form_method != 'get' && this.props.form_method != 'post' &&
        <input name='_method' type='hidden' value={t.props.form_method} />
        }
        {t.hiddenFields()}
        {t.errorAlert()}
        <input type="hidden" name="address[customers_id]" value={this.state.customers_id} />
       {(!this.props.no_login_quote || this.props.show_name_fields ) && 
      <div className="row">
        <div className="col-lg-5">
          <div className={t.cssForField("entry_firstname")}>
          <label htmlFor="address_entry_firstname">First</label>
          <input autoFocus className="form-control" placeholder="First Name" type="text" name="address[entry_firstname]" value={this.state.entry_firstname} onChange={this.handleChange} id="address_entry_firstname"></input>
          {t.errorMessage("entry_firstname")}
          </div>
        </div>
        <div className="col-lg-7">
          <div className={t.cssForField("entry_lastname")}>
          <label htmlFor="address_entry_lastname">Last</label>
          <input className="form-control" placeholder="Last Name" type="text" value={this.state.entry_lastname} onChange={t.handleChange} name="address[entry_lastname]" id="address_entry_lastname"></input>
          {t.errorMessage("entry_lastname")}
          </div>
        </div>
      </div>
        }
     {!this.props.no_login_quote &&
      <div className="row">
        <div className="col-lg-12">
          <div className={t.cssForField("entry_company")}>
          <label htmlFor="address_entry_company">Company</label>
          <input className="form-control" placeholder="Company" type="text" value={this.state.entry_company} onChange={t.handleChange} name="address[entry_company]" id="address_entry_company"></input>
          {t.errorMessage("entry_company")}
          </div>
        </div>
      </div>
        }
      <div className="row">
        <div className="col-lg-12">
          <div className={t.cssForField("entry_street_address")}>
          <label htmlFor="address_entry_street_address">Street Address</label>
          <input className="form-control" placeholder="123 Main St." type="text" value={this.state.entry_street_address} onChange={t.handleChange} name="address[entry_street_address]" id="address_entry_street_address"></input>
          {t.errorMessage("entry_street_address")}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className={t.cssForField("entry_suburb")}>
          <label htmlFor="address_entry_suburb">Line 2</label>
          <input className="form-control" type="text" value={this.state.entry_suburb} onChange={t.handleChange} name="address[entry_suburb]" id="address_entry_suburb"></input>
          {t.errorMessage("entry_suburb")}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className={t.cssForField("entry_country")}>
          <label htmlFor="address_entry_country">Country</label>
<select value={this.state.entry_country_id} onChange={this.countryChange} className="form-control" name="address[entry_country_id]" id="address_entry_country_id" >
{country_options}
</select>
          {t.errorMessage("entry_country")}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3">
          <div className={t.cssForField("entry_postcode")}>
          <label htmlFor="address_entry_postcode">Zipcode</label>
          <input className="form-control" placeholder="Zip" type="text" onBlur={this.getCityState} onChange={this.handleChange} value={this.state.entry_postcode} 
          name="address[entry_postcode]" id="address_entry_postcode"></input>
          {t.errorMessage("entry_postcode")}
          </div>
        </div>
        <div className="col-lg-5">
          <div className={t.cssForField("entry_city")}>
            <label htmlFor="address_entry_city">City</label>
            <input className="form-control" placeholder="City" type="text" value={this.state.entry_city} onChange={this.handleChange} name="address[entry_city]" id="address_entry_city"></input>
          {t.errorMessage("entry_city")}
          </div>
        </div>
        <div className="col-lg-4">
          <div className={t.cssForField("entry_zone_id")}>
            <label htmlFor="address_entry_state">State</label>
            {this.zoneState()}
          {t.errorMessage("entry_state")}
          {t.errorMessage("entry_zone_id")}
          </div>
        </div>
      </div>
      {!this.props.no_login_quote &&
      <div className="row">
        <div className="col-lg-10">

          <div className={t.cssForField("entry_telephone") + " input-group"}>
            <label htmlFor="address_entry_telephone">Phone Number</label>
            <input className="form-control" placeholder="Phone" type="text" value={this.state.entry_telephone} onChange={this.handleChange} name="address[entry_telephone]" id="address_entry_telephone"></input>
          {t.errorMessage("entry_telephone")}
            {is_default_shipping_checkbox}
            {is_default_billing_checkbox}
          </div>
        </div>
      </div>
        }
      <div className="row">
         {!this.props.no_login_quote  &&
        <div className="col-lg-6">
          <a href={Routes.addresses_path()}>Cancel</a>
        </div>
        }
        <div className={this.props.no_login_quote ? "col-lg-12 text-center" : "col-lg-6 text-right" }>
          <button type="submit" className="btn btn-xl btn-default btn-primary">{this.buttonText()}</button>
        </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/store_front/app/components/address_editor.jsx